import { __awaiter, __generator } from "tslib";
import { getMavenoidApiConfig } from '../config/actions';
import { getAccount, getMsalClient } from "../../../auth";
var MavenoidApiClient = /** @class */ (function () {
    function MavenoidApiClient() {
        var _this = this;
        this.getJWTForMavenoid = function () { return __awaiter(_this, void 0, void 0, function () {
            var scopes;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        scopes = getMavenoidApiConfig().scopes;
                        if (!this.account) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.acquireToken({
                                account: this.account,
                                forceRefresh: false,
                                scopes: scopes,
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2: return [2 /*return*/, {
                            errorCode: 401 /* UNAUTHORIZED */,
                            errorMessage: "User Not Logged In",
                            JWT: null
                        }];
                }
            });
        }); };
        this.msalClient = getMsalClient();
    }
    Object.defineProperty(MavenoidApiClient.prototype, "account", {
        get: function () {
            return getAccount();
        },
        enumerable: false,
        configurable: true
    });
    MavenoidApiClient.prototype.acquireToken = function (request) {
        return __awaiter(this, void 0, void 0, function () {
            var accessToken, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.msalClient.acquireTokenSilent(request)];
                    case 1:
                        accessToken = (_a.sent()).accessToken;
                        return [2 /*return*/, ({ JWT: accessToken })];
                    case 2:
                        error_1 = _a.sent();
                        console.warn(error_1);
                        return [2 /*return*/, ({ errorMessage: error_1, errorCode: 403 /* FORBIDDEN */, JWT: null })];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    return MavenoidApiClient;
}());
/** Singleton */
var mavenoidApiClient;
export var initMavenoidApiClient = function () {
    // Check whether it's browser environment or not.
    if (typeof window === undefined) {
        return mavenoidApiClient || (mavenoidApiClient = new MavenoidApiClient());
    }
    var existingClient = window.MavenoidApiClient;
    if (!existingClient) {
        window.MavenoidApiClient = mavenoidApiClient || (mavenoidApiClient = new MavenoidApiClient());
    }
    return window.MavenoidApiClient;
};
